import React, { ReactNode } from 'react';

import AiSmartFilterProvider from 'component/Search/Filter/AiSmartFilter/__context/AiSmartFilterProvider';

import { ContactProvider } from 'context/ContactContext';
import AccommodationProvider from 'context/entity/Accommodation/Accommodation';
import { SearchFormProvider } from 'context/SearchFormContext';
import { TravelExpertProvider } from 'context/TravelExpertContext';
import { Provider as SearchFormStoreProvider } from 'jotai';

import { searchStore } from 'data/Atom/Store';

import DevicedDebugBarEntry from 'utility/Debug/DevicedDebugbar';
import { CommunicationProvider } from 'utility/Provide/Context/PageContext';
import ProviderWrapper from 'utility/Provide/Wrapper';

interface HotelPageProviderProps {
    children: ReactNode;
}

const HotelPageProvider = ({ children }: HotelPageProviderProps) => (
    <ProviderWrapper>
        <CommunicationProvider>
            <ContactProvider>
                <AiSmartFilterProvider>
                    <SearchFormStoreProvider store={searchStore}>
                        <AccommodationProvider initialState={{}}>
                            <TravelExpertProvider>
                                <SearchFormProvider>
                                    {children}
                                </SearchFormProvider>
                            </TravelExpertProvider>
                        </AccommodationProvider>
                        <DevicedDebugBarEntry />
                    </SearchFormStoreProvider>
                </AiSmartFilterProvider>
            </ContactProvider>
        </CommunicationProvider>
    </ProviderWrapper>
);

export default HotelPageProvider;
